import React from "react";
import BaseConverters from "../components/BaseConverters";

export default function Converters() {
  return <BaseConverters mode="converters" />;
}
